import glamorous from 'glamorous';

const TypeAheadSearchWrapper = glamorous.div(
  'ncss-base',
  ({ bgColor }) => ({
    backgroundColor: bgColor,
    boxShadow: 'inset 0 1px 0 0 #ddd, inset -1px 0 0 0 #ddd, inset 0 -1px 0 0 #ddd, inset 1px 0 0 0 #ddd',
    width: '100%',
    position: 'relative',
    display: 'inline-block',
    textAlign: 'left',
    ' input': {
      padding: '8px 16px !important',
      width: '100%',
      boxShadow: 'inset 0 1px 0 0 #ddd, inset -1px 0 0 0 #ddd, inset 0 -1px 0 0 #ddd, inset 1px 0 0 0 #ddd',
      minHeight: '40px',
      ':focus': {
        boxShadow:
        'inset 0 1px 0 0 #6D6D6D,inset -1px 0 0 0 #6D6D6D,inset 0 -1px 0 0 #6D6D6D,inset 1px 0 0 0 #6D6D6D',
      },
    },
    ' ul': {
      zIndex: '100',
      boxShadow:
        'inset 0 0px 0 0 #ddd, inset -1px 0 0 0 #ddd, inset 0 -1px 0 0 #ddd, inset 1px 0 0 0 #ddd !important',
      backgroundColor: 'white',
    },
    ' .sub-text': {
      color: '#8D8D8D',
      fontStyle: 'italic',
      fontSize: '12px',
    },
    ' .sr-only': {
      display: 'none',
    },
    ' .rbt-input-hint': {
      visibility: 'hidden',
    },
    ' .rbt-token': {
      display: 'inline-block',
      padding: '0 30px 0px 15px',
      height: '30px',
      fontSize: '14px',
      position: 'relative',
      lineHeight: '30px',
      borderRadius: '15px',
      backgroundColor: '#f1f1f1',
      color: '#111',
      '& .rbt-token-remove-button' : {
        padding: '0px 0px',
        right: '5px',
        top: '0px'
        
      },
    },
    ' .rbt-close': {
      borderRadius: '15px',
      backgroundColor: '#f1f1f1',
      paddingTop: '3px'
    },
    ' li': {
      padding: '8px 16px',
      cursor: 'pointer',
      ':hover': {
        backgroundColor: '#f4f4f4',
      },
      '.active': {
        backgroundColor: '#DDDDDD',
      },
    },
    ' a':
    {
      display: 'flex',
    },
    ' .disabled': {
      textDecoration: 'none !important',
    },
  }
  ),
);
TypeAheadSearchWrapper.displayName = 'TypeAheadSearchWrapper';

export default TypeAheadSearchWrapper;


// WEBPACK FOOTER //
// ./src/components/TypeAheadSearch/TypeAheadSearch.style.js